import { Empty } from 'antd';
import { CSSProperties } from 'react';
import { useIntl } from 'react-intl';
import { FaFolderOpen } from 'react-icons/fa';

interface DefaultEmptyProps {
  style?: CSSProperties;
  className?: string;
}

function DefaultEmpty({ style, className }: DefaultEmptyProps) {
  const intl = useIntl();

  return (
    <Empty
      image={<FaFolderOpen size={64} />}
      description={intl.formatMessage({ id: 'commons.noData' })}
      style={style}
      className={className}
    ></Empty>
  );
}

export default DefaultEmpty;
